<template>
    <div>
        <Header />
        <KeyFeatures />
        <EasyToUseAPI />
        <SuccessStories />
        <AppMarketplace />
    </div>
</template>

<script>
import Header from './Header.vue'
import EasyToUseAPI from './EasyToUseAPI.vue'
import KeyFeatures from './KeyFeatures.vue'
import SuccessStories from './SuccessStories.vue'
import AppMarketplace from './AppMarketplace.vue'
export default {
    name: 'Main',
    components: {Header, KeyFeatures, EasyToUseAPI, SuccessStories, AppMarketplace}
}
</script>

<style scoped>

</style>